import "core-js/modules/es6.array.filter.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var sampleLoadingTablesDeleted = produce(function (draft, action) {
  var _action$payload = action.payload,
    id = _action$payload.id,
    isActive = _action$payload.isActive;
  draft.ids = draft.ids.filter(function (sltId) {
    return sltId !== id;
  });
  delete draft[id];
  if (isActive) {
    draft.meta.activeSltId = draft.ids[0] || null;
  }
}, initialState);
export default sampleLoadingTablesDeleted;